module.exports = __webpack_public_path__ + "static/media/note_sms.c6f2f3ee.mp3";